let t = {};
function e() {
  return t;
}
export {
  e as getDefaultOptions
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/_lib/defaultOptions.js
// module id = 193
// module chunks = 41